import React from 'react'
import PropTypes from 'prop-types'

import * as Styled from './Tombstone.styles'

const isLongText = (text, characters = 5) => text && text.length > characters

const Tombstone = ({ data, 'data-test': dataTest }) => {
  const { title, quantities, percentage, colorCoding } = data
  const quantityElements = quantities.map((quantity, index) => <span key={index}>{quantity}</span>)
  return (
    <Styled.Container colorCoding={colorCoding} data-test={dataTest}>
      <span>{title}</span>
      <Styled.Quantity>{quantityElements}</Styled.Quantity>
      <Styled.Percentage colorCoding={colorCoding} longText={isLongText(percentage)}>
        <span>{percentage}</span>
      </Styled.Percentage>
    </Styled.Container>
  )
}

Tombstone.propTypes = {
  /**
   * Tombstone label data
   */
  data: PropTypes.shape({
    title: PropTypes.string,
    quantities: PropTypes.array,
    percentage: PropTypes.string,
    colorCoding: PropTypes.string
  }).isRequired,
  /**
   * Colour coding (high, medium, low)
   */
  colorCoding: PropTypes.string,
  /**
   * Specify an optional data-test attribute to be added for e2e testing
   */
  'data-test': PropTypes.string
}

Tombstone.defaultProps = {
  'data-test': 'tombstone'
}

export default Tombstone
